import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type AllAccountsQueryVariables = GraphQLTypes.Exact<{
  accountsFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.AccountsFiltersInput>;
  nestedBusinessUnits?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
}>;

export type AllAccountsQueryResult = { __typename?: 'Query' } & {
  accounts?: GraphQLTypes.Maybe<
    { __typename?: 'AccountConnection' } & {
      nodes: Array<
        GraphQLTypes.Maybe<
          { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'> & {
              label?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>>;
            }
        >
      >;
    }
  >;
};

export const AllAccountsDocument = gql`
  query allAccounts($accountsFiltersInput: AccountsFiltersInput, $nestedBusinessUnits: Boolean) {
    accounts(accountsFiltersInput: $accountsFiltersInput, nestedBusinessUnits: $nestedBusinessUnits) {
      nodes {
        id
        label {
          long
        }
        tradingName
      }
    }
  }
`;
